import Dialog from '@anm/components/modals/Dialog';
import AlertBlock from '@anm/components/notification/AlertBlock';
import { FC } from 'react';
import { useSelector } from 'react-redux';

import { videoFolderSelectors } from '../../../../store/modules/videoFolder';

export type AlreadyInsideAlertProps = {
  projectId: string;
  onClose: (v: boolean) => void;
};

const AlreadyInsideAlert: FC<AlreadyInsideAlertProps> = ({ projectId, onClose }) => {
  const currentFolder = useSelector(videoFolderSelectors.selectCurrentFolder);
  const currentProject = useSelector(state => videoFolderSelectors.selectProjectById(state, projectId));

  if (!currentProject) {
    throw new Error(`Can not to find project with id: ${projectId}`);
  }

  if (!currentFolder) throw new Error('current folder data is empty ');

  const closeModal = () => onClose(false);

  return (
    <Dialog onModalClose={closeModal} onSubmit={closeModal}>
      <AlertBlock
        title="This is your current folder"
        description="Please pick a new one for your video."
        onButtonClick={closeModal}
      />
    </Dialog>
  );
};

export default AlreadyInsideAlert;
